import { Link } from '@mui/material';
import React from 'react';

const SyncedInfoLink = ({ name, url }) => {
  return (
    <Link
      href={`${url}?web=1`}
      target="_blank"
      rel="noopener noreferrer"
      className="external-source-link content-item-link-ref"
      data-testid="autosynced-soure-external-source"
      sx={{
        fontWeight: '500',
        textDecoration: 'underline',
      }}
    >
      {name}
    </Link>
  );
};

export default SyncedInfoLink;
